import { render, staticRenderFns } from "./AddArtistWizard.vue?vue&type=template&id=5cd112b0&scoped=true&"
import script from "./AddArtistWizard.vue?vue&type=script&lang=js&"
export * from "./AddArtistWizard.vue?vue&type=script&lang=js&"
import style0 from "./AddArtistWizard.vue?vue&type=style&index=0&id=5cd112b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd112b0",
  null
  
)

export default component.exports